module.exports = __webpack_public_path__ + "media/images/back-crowd@2x-212039e5.jpg";